import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import {
  DiscountCampaings,
  PackCampaign,
  RunPetisSimulationClientResponse,
} from '../@types/RunPetisSimulation'

export type CampaignsList = {
  [key: string]: PackCampaign[]
}

type Store = {
  isReferral: boolean
  isReferralWarning: boolean
  hasRunPetisUpdated: boolean
  enabledRunPetisRequest: boolean
  packsCampaigns: DiscountCampaings[] | null
  selectedPackCampaign: DiscountCampaings | null
  setPacksCampaigns: (packsCampaigns: DiscountCampaings[]) => void
  previousPackCampaign: DiscountCampaings | null
  setPreviousPackCampaign: (previousPackCampaign: DiscountCampaings) => void
  setEnabledRunPetisRequest: (enabledRunPetisRequest: boolean) => void
  setSelectedPackCampaign: (
    selectedPackCampaign: DiscountCampaings | null,
  ) => void
  resetCampaigns: () => void
  setIsReferral: (value: boolean) => void
  setIsReferralWarning: (value: boolean) => void
  setHasRunPetisUpdated: (value: boolean) => void
  runPetisSimulation: RunPetisSimulationClientResponse | null
  setRunPetisSimulation: (value: RunPetisSimulationClientResponse) => void
  isRequestLoading: boolean
  setIsRequestLoading: (value: boolean) => void
}

export const useRunPetisSimulationStore = create<Store>()(
  devtools(
    (set) => ({
      runPetisSimulation: null,
      packsCampaigns: null,
      selectedPackCampaign: null,
      enabledRunPetisRequest: false,
      setRunPetisSimulation: (runPetisSimulation) =>
        set({ runPetisSimulation }),
      isReferral: false,
      isReferralWarning: false,
      hasRunPetisUpdated: true,
      resetCampaigns: () =>
        set({ previousPackCampaign: null, selectedPackCampaign: null }),
      setIsReferral: (isReferral) => set({ isReferral }),
      setEnabledRunPetisRequest: (enabledRunPetisRequest) =>
        set({ enabledRunPetisRequest }),
      setIsReferralWarning: (isReferralWarning) => set({ isReferralWarning }),
      setPacksCampaigns: (packsCampaigns) => set({ packsCampaigns }),
      setSelectedPackCampaign: (_selectedPackCampaign) =>
        set({ selectedPackCampaign: _selectedPackCampaign }),
      previousPackCampaign: null,
      setPreviousPackCampaign: (previousPackCampaign) =>
        set({ previousPackCampaign }),
      setHasRunPetisUpdated: (hasRunPetisUpdated) =>
        set({ hasRunPetisUpdated }),
      isRequestLoading: false,
      setIsRequestLoading: (isRequestLoading) => set({ isRequestLoading }),
      requestQuotationQuoteId: '',
    }),
    { name: 'RunPetisSimulationStore' },
  ),
)
